// extracted by mini-css-extract-plugin
export default {"page":"FX-z","cartModal":"GX-z","checkout":"HX-z","placeholder":"IX-z","account":"JX-z"};